export default function pluralize(word: string, count: number = 2): string {
  if (count === 1) {
    // Singular form
    return word;
  }

  // Handle words that are already plural or should not be pluralized
  if (word.endsWith("s")) {
    return word;
  }

  // Basic rules for pluralization
  if (word.endsWith("y") && !"aeiou".includes(word[word.length - 2])) {
    // Words ending in consonant + "y" → change "y" to "ies"
    return word.slice(0, -1) + "ies";
  } else if (word.endsWith("x") || word.endsWith("z") || word.endsWith("sh") || word.endsWith("ch")) {
    // Words ending in x, z, sh, ch → add "es"
    return word + "es";
  } else {
    // Regular case → add "s"
    return word + "s";
  }
}
